import React from 'react';
import PropTypes from 'prop-types';
import { Pencil } from 'lucide-react';
import styled, { useTheme } from 'styled-components';

// Styled container matching rombo's MultiValueContainer
const StyledMultiValueContainer = styled.div`
  background-color: ${({ theme, $isEditable }) => ($isEditable ? theme?.colors?.purple?.[100] : 'transparent')};
  border-radius: 9999px;
  border: 1px solid ${({ theme }) => theme?.colors?.border?.subtle};
  padding: 2px 4px 2px 8px;
  margin-right: 4px;
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme?.colors?.text?.main};
  max-width: 100%;
  min-width: 0;
  gap: 4px;

  &:hover {
    background-color: ${({ theme, $isEditable }) =>
      $isEditable ? theme?.colors?.purple?.[100] : theme?.colors?.neutral?.[20]};
  }
`;

const EditButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme?.colors?.neutral?.[400]};

  &:hover {
    color: ${({ theme }) => theme?.colors?.neutral?.[600]};
  }
`;

export const EditableMultiValueContainer = ({ children, data, innerProps, selectProps }) => {
  const theme = useTheme();
  const isEditable = data?.isEditable;

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (selectProps.onEditValue) {
      selectProps.onEditValue(data);
    }
  };

  return (
    <StyledMultiValueContainer {...innerProps} theme={theme} $isEditable={isEditable}>
      {children}
      {isEditable && (
        <EditButton type="button" onClick={handleEditClick} aria-label={`Edit ${data?.label ?? 'value'}`} theme={theme}>
          <Pencil size={14} aria-hidden="true" />
        </EditButton>
      )}
    </StyledMultiValueContainer>
  );
};

EditableMultiValueContainer.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.shape({
    isEditable: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  innerProps: PropTypes.object,
  selectProps: PropTypes.shape({
    onEditValue: PropTypes.func,
  }),
};

EditableMultiValueContainer.defaultProps = {
  innerProps: {},
  selectProps: {},
};
